import { render, staticRenderFns } from "./MainArticles2.vue?vue&type=template&id=7aef3d9b&"
import script from "./MainArticles2.vue?vue&type=script&lang=js&"
export * from "./MainArticles2.vue?vue&type=script&lang=js&"
import style0 from "./MainArticles2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports